import Bio from './Bio';
import ContentColumns from './ContentColumns';
import Driver from './Driver';
import PressTrio from './PressTrio';
import Hireology from './Hireology';
import ImageCarousel from './ImageCarousel';
import ImageDuo from './ImageDuo';
import ImageFullWidth from './ImageFullWidth';
import ImageTextFullWidthOverlap from './ImageTextFullWidthOverlap';
import ImageTextOverlap from './ImageTextOverlap';
import ImageTextOverlapProduct from './ImageTextOverlapProduct';
import ImageText from './ImageText';
import ImageTextTrio from './ImageTextTrio';
import ProductCarousel from './ProductCarousel';
import Quote from './Quote';
import QuoteCarousel from './QuoteCarousel';
import VideoTextOverlap from './VideoTextOverlap';
import ComponentNotFound from './ComponentNotFound';
import VideoTextFullWidthOverlap from './VideoTextFullWidthOverlap';
import Careers from './CareerItem/careerList';
import FeaturedModules from './FeaturedModules';
import ImageTextOverlapFramed from './ImageTextOverlapFramed';

const ComponentList = {
  bio: Bio,
  contentColumns: ContentColumns,
  driver: Driver,
  pressTrio: PressTrio,
  hireology: Hireology,
  imageCarousel: ImageCarousel,
  imageDuo: ImageDuo,
  imageFullWidth: ImageFullWidth,
  imageTextFullWidthOverlap: ImageTextFullWidthOverlap,
  imageTextOverlap: ImageTextOverlap,
  imageTextOverlapFramed: ImageTextOverlapFramed,
  imageTextOverlapProduct: ImageTextOverlapProduct,
  imageText: ImageText,
  imageTextTrio: ImageTextTrio,
  productCarousel: ProductCarousel,
  featuredProductCarousel: ProductCarousel,
  quote: Quote,
  quoteCarousel: QuoteCarousel,
  videoTextFullWidthOverlap: VideoTextFullWidthOverlap,
  videoTextOverlap: VideoTextOverlap,
  careerListing: Careers,
  featuredModules: FeaturedModules,
};

const Components = (type) => {
  if (typeof ComponentList[type] === 'undefined') {
    return ComponentNotFound;
  }
  return ComponentList[type];
};

export default Components;
